import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class DataBaseServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params) {
    return this.http.get('', { params: params });
  }
}

export const DataBaseService = new DataBaseServiceClass({
  api_version: 3,
  resource: 'databases'
});
